import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ActivityRecordingDelete as ActivityRecordingDeleteMutation,
    ActivityRecordingDeleteVariables as ActivityRecordingDeleteVariables,
    ActivityRecordingDeleteInput,
} from 'nutshell-graphql-types';

import ACTIVITY_RECORDING_DELETE from '../mutations/activity-recording-delete.graphql';

export const useActivityRecordingDelete = (): {
    activityRecordingDelete: (arg1: ActivityRecordingDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [activityRecordingDelete, {loading, error}] = useMutation<
        ActivityRecordingDeleteMutation,
        ActivityRecordingDeleteVariables
    >(ACTIVITY_RECORDING_DELETE);

    return {
        activityRecordingDelete: (input: ActivityRecordingDeleteInput) =>
            activityRecordingDelete({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
